import React from 'react'

export const Resume = () => {
  return (
    <>
      <div class="section">
        <h2>Work Experience</h2>
        <div class="job">
          <h3>Hawaii Federal Credit Union, IT Intern</h3>
          <p><strong>Location:</strong> Honolulu, Hawaii</p>
          <p><strong>Dates:</strong> June 2016 - July 2016</p>
          <p><strong>Duties:</strong> Organized data using Excel, disposed e-waste, destroyed hard drives, performed maintenance on other branches.</p>
        </div>
        <div class="job">
          <h3>Land Park Business Services, Customer Service</h3>
          <p><strong>Location:</strong> Sacramento, California</p>
          <p><strong>Dates:</strong> September 2022 - Present</p>
          <p><strong>Duties:</strong> Managed mailbox rentals, sorted incoming mail, operated printers for both black and white and color printing, packaged and shipped parcels.</p>
        </div>
      </div>
      <div class="section">
        <h2>Education</h2>
        <p><strong>Bachelor of Science - Computer Science</strong></p>
        <p><strong>School:</strong> California State University, Sacramento, CA</p>
        <p><strong>Expected Graduation:</strong> May 2025</p>
        <br />
        <p><strong>Associate in Science CIS - Computer Science</strong></p>
        <p><strong>School:</strong> Cosumnes River College, Sacramento, CA</p>
        <p><strong>Graduation:</strong> December 2021</p>
      </div>
      <div class="section">
        <h2>Skills</h2>
        <ul>
          <li>Programming: Python, Java, C++, C#, HTML, CSS, JavaScript, React, Github</li>
          <li>Active Directory: Domain, Organizational Unit (OU), Computer accounts, User accounts, Security Group</li>
          <li>Networking: Ping, nslookup, DNS, DHCP, VLANs</li>
          <li>MS Office: Word, Excel, PowerPoint, OneNote</li>
          <li>Virtual Machines: Clone, delete</li>
        </ul>
      </div>
    </>
  )
}